import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Show } from "@clerk/react";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { Toaster } from "@/components/ui/sonner";
import { MemberProvider, useMember } from "@/context/MemberContext";
import { Loader } from "@/components/common";
import AppShell from "@/components/AppShell";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import ClockPage from "@/pages/ClockPage";
import Planning from "@/pages/Planning";
import Employees from "@/pages/Employees";
import Board from "@/pages/Board";
import Timesheet from "@/pages/Timesheet";
import SettingsPage from "@/pages/SettingsPage";
import Privacy from "@/pages/Privacy";
import Assistant from "@/pages/Assistant";
import Availability from "@/pages/Availability";
import Swaps from "@/pages/Swaps";

function MemberGate() {
  const m = useMember();
  if (m.loading) return <Loader full />;
  if (m.error) return <p className="p-8 text-center">Kon je gegevens niet laden. Vernieuw de pagina.</p>;
  if (!m.member) return <Navigate to="/welkom" replace />;
  return <AppShell />;
}

function Root() {
  const loc = useLocation();
  return (
    <>
      <Show when="signed-out">{loc.pathname === "/" ? <Landing /> : <Navigate to="/sign-in" replace />}</Show>
      <Show when="signed-in">
        <MemberProvider>
          <MemberGate />
        </MemberProvider>
      </Show>
    </>
  );
}

const ManagerOnly = ({ children }) => {
  const { isManager } = useMember();
  return isManager ? children : <Navigate to="/" replace />;
};

function App() {
  return (
    <BrowserRouter>
      <ClerkAuthProvider>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/sign-in/*" element={<AuthPage mode="in" />} />
          <Route path="/sign-up/*" element={<AuthPage mode="up" />} />
          <Route
            path="/welkom"
            element={
              <>
                <Show when="signed-in"><MemberProvider><Onboarding /></MemberProvider></Show>
                <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
              </>
            }
          />
          <Route path="/" element={<Root />}>
            <Route index element={<Dashboard />} />
            <Route path="klokken" element={<ClockPage />} />
            <Route path="planning" element={<Planning />} />
            <Route path="prikbord" element={<Board />} />
            <Route path="uren" element={<Timesheet />} />
            <Route path="ruilen" element={<Swaps />} />
            <Route path="beschikbaarheid" element={<Availability />} />
            <Route path="assistent" element={<ManagerOnly><Assistant /></ManagerOnly>} />
            <Route path="medewerkers" element={<ManagerOnly><Employees /></ManagerOnly>} />
            <Route path="instellingen" element={<SettingsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </ClerkAuthProvider>
    </BrowserRouter>
  );
}

export default App;
